import { Exclude, Expose, Transform, TransformFnParams, Type } from 'class-transformer';

import { OrderLine } from './order-line';
import { LocalImage } from './local-image';
import { WorkOrder } from './work-order';
import { IImage, IOrder } from '@vandelft/shared/interfaces';
import { DepositHelper, OptionsHelper, OrderHelper, QuantifiedProductHelper } from '@vandelft/shared/helpers';
import { Image } from './image';
import { BaseFile } from './base-file';

@Exclude()
export class Order implements IOrder {
  @Expose()
  public id: string;

  @Expose()
  public workOrderId: string;

  @Expose()
  public takenProduct: string;

  @Expose()
  public doorMaterial: string;

  @Expose()
  public frameMaterial: string;

  @Expose()
  public doorType: string;

  @Expose()
  @Transform((value: TransformFnParams) => !!value.value)
  public cylinderOperated: boolean;

  @Expose()
  public backsetLock: number;

  @Expose()
  public spacingLock: number;

  @Expose()
  @Transform((value: TransformFnParams) => !!value.value)
  public keyRepeatOrder: boolean;

  @Expose()
  @Transform((value: TransformFnParams) => !!value.value)
  public cylinder: boolean;

  @Expose()
  public cylinderBrand: string;

  @Expose()
  public cylinderNumber: string;

  @Expose()
  public remarks: string;

  @Expose()
  @Type(() => LocalImage)
  public localCertificates: LocalImage[];

  @Expose()
  @Type(() => LocalImage)
  public localProductImages: LocalImage[];

  @Expose()
  @Type(() => OrderLine)
  public orderLines: OrderLine[];

  @Expose()
  @Type(() => BaseFile, {
    discriminator: {
      property: 'internalType',
      subTypes: [
        { value: Image, name: 'image' },
        { value: LocalImage, name: 'localImage' },
      ],
    },
  })
  public images?: Image[] | LocalImage[];

  @Expose()
  public deposit: number;

  @Expose()
  @Type(() => Image)
  public certificate: Image;

  @Expose()
  @Type(() => Image)
  public productImage: Image;

  @Expose()
  @Type(() => WorkOrder)
  public workOrder: WorkOrder;

  public get productImages(): IImage[] | undefined {
    return OrderHelper.getProductImages(this);
  }

  public get certificates(): IImage[] | undefined {
    return OrderHelper.getCertificates(this);
  }

  public get calculatedDeposit(): number {
    return DepositHelper.getDeposit(this.orderLines);
  }

  public get effectiveDeposit(): number {
    if (!this.deposit) {
      return this.calculatedDeposit;
    }

    return this.deposit;
  }

  public get totalPriceExc(): number {
    return QuantifiedProductHelper.getTotalPriceExc(this.orderLines);
  }

  public get totalTax(): number {
    return QuantifiedProductHelper.getTotalTax(this.orderLines);
  }

  public get totalPriceInc(): number {
    return QuantifiedProductHelper.getTotalPriceInc(this.orderLines);
  }

  public get options(): any {
    return OptionsHelper.getSelectedOptions(this);
  }
}
